import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_JA_P3B } from './seo-comparison-p3b.ja';


const SITEMINDER_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io vs SiteMinder',
  heroSubtitle: 'SiteMinderは2006年設立のオーストラリアのチャネルマネージャーで、OTA流通に特化しています。HotelStack.ioは、内蔵チャネル管理、PMS、F&B、収益ツールなどを含む完全な36モジュールホテル管理プラットフォームを、より低価格で提供します。',
  overviewComparison: [
    { label: 'プラットフォーム種別', hotelstack: 'オールインワンHMS（36モジュール）', competitor: 'チャネルマネージャー＋アドオン' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$99以上' },
    { label: '内蔵PMS', hotelstack: 'フルPMS含む', competitor: 'Little Hotelier（別製品）' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: 'レベニューマネジメント', hotelstack: '高度（内蔵）', competitor: '基本イールドルール' },
    { label: '予約エンジン', hotelstack: 'BookMyRoom.io（無料）', competitor: 'TheBookingButton（アドオン）' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: false },
        { name: '予約管理', hotelstack: true, competitor: 'Little Hotelier経由' },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: false },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: false },
        { name: 'グループ予約', hotelstack: true, competitor: false },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '流通・チャネル管理',
      features: [
        { name: 'チャネルマネージャー（100以上のOTA）', hotelstack: true, competitor: true },
        { name: 'GDS接続', hotelstack: true, competitor: true },
        { name: 'メタサーチ統合', hotelstack: true, competitor: true },
        { name: 'レートパリティモニタリング', hotelstack: true, competitor: true },
        { name: 'ダイレクト予約エンジン', hotelstack: true, competitor: 'アドオン' },
      ],
    },
    {
      category: 'レベニューマネジメント',
      features: [
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: '基本' },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'ゲスト・オペレーション',
      features: [
        { name: '360度ゲストプロファイル', hotelstack: true, competitor: false },
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: false },
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'マルチプロパティ・コンプライアンス',
      features: [
        { name: 'チェーンダッシュボード', hotelstack: true, competitor: '制限あり' },
        { name: 'クロスプロパティ分析', hotelstack: true, competitor: false },
        { name: '多通貨請求', hotelstack: true, competitor: '制限あり' },
        { name: '地域税コンプライアンス', hotelstack: true, competitor: false },
        { name: 'ロイヤルティプログラム管理', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: false },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: '36モジュールすべて含む — PMS、チャネルマネージャー、予約エンジン、F&B、レベニューマネジメント。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングと移行。',
    competitorNote: 'チャネルマネージャー月額$99以上。PMS（Little Hotelier）と予約エンジン（TheBookingButton）は別製品・別料金。F&Bやオペレーションモジュールなし。',
  },
  advantages: [
    'SiteMinderのチャネルマネージャーのみのアプローチに対して、36モジュール搭載の完全なオールインワンプラットフォーム',
    'フルPMS内蔵 — 施設管理にLittle Hotelierを別途購入する必要なし',
    'F&B、POS、ルームサービス、キッチン管理が追加費用なしで含む',
    'ダイナミックプライシング、予測、What-Ifシミュレーターを備えた高度なレベニューマネジメント',
    '360度プロファイル、ロイヤルティプログラム、自動コミュニケーションを備えたゲストCRM',
    'ハウスキーピング、メンテナンス、スタッフスケジューリングの統合オペレーションツール',
    'より多くの機能を含みながら開始価格が低い（$49対$99以上）',
    '24時間365日専任サポート付きの無料オンボーディングとデータ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'SiteMinderは約20年にわたり構築された強力なOTA接続を持つスタンドアロンチャネルマネージャーとして優れています。しかし、完全なホテル管理プラットフォームではありません。HotelStack.ioはSiteMinderが提供する流通機能のすべてに加え、フルPMS、F&B/POS、レベニューマネジメント、ゲストCRM、25以上の追加モジュールを、1つのサブスクリプションでより低価格で提供します。',
    bestFor: [
      'SiteMinder＋PMS＋POSを組み合わせる代わりに単一プラットフォームを求めるホテル',
      'チャネル管理を超えたフルPMS、F&B、オペレーションツールが必要な施設',
      '高度なレベニューマネジメントと需要予測を求めるホテル',
      '流通だけではSiteMinderが高すぎると感じる小規模施設',
      'すべてのオペレーションにわたる一元管理が必要なマルチプロパティチェーン',
    ],
  },
  faqItems: [
    { question: 'SiteMinderからHotelStack.ioに移行できますか？', answer: '当社の移行チームがOTA接続、料金プラン、予約データを移行します。HotelStack.ioはSiteMinderがサポートする同じ100以上のOTAに接続します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioはSiteMinderのチャネル管理機能に匹敵しますか？', answer: 'はい。HotelStack.ioは100以上のOTA、AmadeusとSabre経由のGDS、メタサーチプラットフォームに接続するフルチャネルマネージャーを含みます。レートパリティモニタリングとリアルタイム在庫同期はすべてのプランの標準機能です。' },
    { question: 'SiteMinder＋Little Hotelierの代わりにHotelStack.ioを選ぶ理由は？', answer: 'SiteMinder（チャネルマネージャー）＋Little Hotelier（PMS）＋TheBookingButton（予約エンジン）を別々に購入すると、HotelStack.ioよりもはるかに高コストになりますが、F&B、レベニューマネジメント、スタッフスケジューリングなど20以上のモジュールが不足しています。' },
    { question: '現在SiteMinderを使用している小規模施設にHotelStack.ioは適していますか？', answer: 'もちろんです。月額$49のスタータープランには機能制限なしの36モジュールすべてが含まれています。小規模施設はチャネルマネージャーだけでなく、SiteMinder単体よりも低い総コストで完全な管理プラットフォームを得られます。' },
  ],
};

const ROOMRACCOON_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io vs RoomRaccoon',
  heroSubtitle: 'RoomRaccoonはブティックや小規模ホテルをターゲットにしたオランダのAI駆動HMSです。HotelStack.ioは36モジュール、高度なレベニューマネジメント、フルF&B/POS、マルチプロパティサポートで、ブティックからエンタープライズまでスケールします。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36の統合モジュール', competitor: '10以上のモジュール' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$79以上' },
    { label: '対象セグメント', hotelstack: '中小企業からエンタープライズ', competitor: 'ブティック/小規模ホテル' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: 'マルチプロパティ', hotelstack: 'フルチェーン管理', competitor: '制限あり' },
    { label: 'グローバル展開', hotelstack: '40か国以上', competitor: '主にヨーロッパ' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: true },
        { name: 'グループ予約', hotelstack: true, competitor: '制限あり' },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '収益・流通',
      features: [
        { name: 'チャネルマネージャー（100以上のOTA）', hotelstack: true, competitor: 'OTA数限定' },
        { name: 'AI搭載イールド管理', hotelstack: true, competitor: true },
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: '基本' },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'ゲスト管理',
      features: [
        { name: '360度ゲストプロファイル', hotelstack: true, competitor: '基本' },
        { name: 'ロイヤルティプログラム管理', hotelstack: true, competitor: false },
        { name: 'ゲストコミュニケーション自動化', hotelstack: true, competitor: true },
        { name: 'ゲスト消費分析', hotelstack: true, competitor: false },
        { name: 'ID/本人確認アップロード', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B・オペレーション',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: true },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'エンタープライズ・マルチプロパティ',
      features: [
        { name: 'チェーンダッシュボード', hotelstack: true, competitor: '制限あり' },
        { name: 'クロスプロパティ分析', hotelstack: true, competitor: false },
        { name: '一元レート管理', hotelstack: true, competitor: false },
        { name: 'ブランド基準管理', hotelstack: true, competitor: false },
        { name: 'プラットフォームスーパー管理者', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: '制限あり' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: '36モジュールすべて含む。10室のブティックから500室以上のエンタープライズまでスケール。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングと移行。',
    competitorNote: 'EUR 79以上/月のティアード料金。上位ティアに高度な機能がロック。エンタープライズとマルチプロパティ機能は制限あり。',
  },
  advantages: [
    'モジュール数が3倍以上（36対10以上）、プレミアムティアに機能がロックされない',
    'ブティックからエンタープライズまでスケール — RoomRaccoonは小中規模施設に制限',
    'POS、ルームサービス、キッチン管理を含む完全なF&Bモジュール',
    '一元分析とレート配信を備えたフルマルチプロパティチェーン管理',
    '基本的なAIイールドを超えた高度なレベニューマネジメント — 予測とシミュレーターを含む',
    'ゲスト維持とリピート予約増加のためのロイヤルティプログラム管理',
    'RoomRaccoonのヨーロッパフォーカスに対して40か国以上のグローバルリーチ',
    'スケジューリング、給与、パフォーマンス追跡を含むスタッフ管理',
  ],
  verdict: {
    title: '総合評価',
    summary: 'RoomRaccoonはAI搭載PMSとモダンインターフェースを求めるヨーロッパの小規模ブティックホテルには堅実な選択肢です。しかし、成長する施設が必要とする深さ、スケーラビリティ、運用の幅が不足しています。HotelStack.ioはRoomRaccoonが提供するすべてに加え、F&B/POS、エンタープライズマルチプロパティ管理、高度な収益ツール、グローバルコンプライアンスを提供 — より強力な長期投資です。',
    bestFor: [
      'エンタープライズ料金なしでエンタープライズグレードの機能を求めるブティックホテル',
      'HMSにF&B、POS、キッチン管理が必要な施設',
      '単一施設からマルチプロパティチェーンへのスケールを計画しているホテル',
      'グローバルコンプライアンスと流通が必要なヨーロッパ外の施設',
      '基本的なイールド最適化を超えた高度なレベニューマネジメントを求めるホテル',
    ],
  },
  faqItems: [
    { question: 'RoomRaccoonからHotelStack.ioに移行できますか？', answer: '当社の移行チームがゲストプロファイル、予約履歴、料金プラン、客室設定を含むRoomRaccoonからの完全なデータ移行を担当します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioにはRoomRaccoonのようなAI搭載機能がありますか？', answer: 'はい。HotelStack.ioにはインテリジェントイールド管理、需要予測、ダイナミックプライシングルール、収益シミュレーターが含まれています。AI駆動ツールは基本的なイールド最適化を超えて、競合モニタリングとWhat-Ifシナリオプランニングを含みます。' },
    { question: 'RoomRaccoonのようなブティックホテルにHotelStack.ioは適していますか？', answer: 'もちろんです。スタータープランはブティックホテルを含むすべての規模の施設向けに設計されています。初日からすべての36モジュールが機能制限なしで利用でき、モダンダークラグジュアリーUIはブティック施設が好むエレガントな体験を提供します。' },
    { question: 'RoomRaccoonと比較してHotelStack.ioのマルチプロパティ管理はどうですか？', answer: 'HotelStack.ioにはクロスプロパティ分析、一元レート配信、ブランド基準、統合レポートを備えたフルチェーン管理ダッシュボードが含まれています。RoomRaccoonはマルチプロパティサポートが制限されているため、成長するホテルグループにはHotelStack.ioがより良い選択です。' },
  ],
};

export const COMPARISON_JA_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_JA,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_JA,
  ...COMPARISON_JA_P3B,
};
